import { FormattedMessage } from "react-intl";

import { Badge } from "@ps-design-system/components/Badge";
import { Button } from "@ps-design-system/components/Button";
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@ps-design-system/components/Dialog";
import { Text } from "@ps-design-system/components/Text";

import { useHostHubWelcomeDialog } from "../hooks/useHostHubWelcomeDialog";

type HostHubWelcomeDialogProps = {
  isHost: boolean;
  ssoId?: string;
};

const HostHubWelcomeDialog = ({ isHost, ssoId }: HostHubWelcomeDialogProps) => {
  const { dismiss, handleOpenChange, isOpen } = useHostHubWelcomeDialog({
    isHost,
    ssoId,
  });

  if (!isOpen) {
    return null;
  }

  return (
    <Dialog open={isOpen} onOpenChange={handleOpenChange}>
      <DialogContent size="lg" testId="host-hub-welcome-dialog">
        <DialogHeader headerAlignment="left" showCloseButton>
          <div className="tw-flex tw-flex-col tw-gap-12">
            <div>
              <Badge appearance="purple" size="sm">
                <FormattedMessage
                  defaultMessage="NEW!"
                  id="host_hub.welcome_dialog.badge"
                />
              </Badge>
            </div>
            <DialogTitle className="tw-my-0">
              <FormattedMessage
                defaultMessage="Welcome to your host hub"
                id="host_hub.welcome_dialog.title"
              />
            </DialogTitle>
          </div>
        </DialogHeader>
        <DialogBody className="tw-py-32">
          <div className="tw-flex tw-flex-col tw-gap-24">
            <Text className="tw-m-0" element="p" typeface="body-2">
              <Text element="span" typeface="body-2-m">
                <FormattedMessage
                  defaultMessage="Hosting on Peerspace just got a whole lot easier."
                  id="host_hub.welcome_dialog.body_paragraph_one_lead"
                />
              </Text>{" "}
              <FormattedMessage
                defaultMessage="Host hub brings your upcoming bookings and prioritized to-do list together in one place, so you always know what needs attention and when."
                id="host_hub.welcome_dialog.body_paragraph_one"
              />
            </Text>
            <Text className="tw-m-0" element="p" typeface="body-2">
              <FormattedMessage
                defaultMessage="Think of it as your actions and tips, tailored to you. Top priority items are ones to act on fast — respond quickly and you're more likely to land the booking. Recommended items help you stand out as a host and make managing your listings that much easier."
                id="host_hub.welcome_dialog.body_paragraph_two"
              />
            </Text>
            <Text className="tw-m-0" element="p" typeface="body-2">
              <FormattedMessage
                defaultMessage="Spend less time managing, more time delivering the experiences your guests will rave about."
                id="host_hub.welcome_dialog.body_paragraph_three"
              />
            </Text>
          </div>
        </DialogBody>
        <DialogFooter>
          <Button onClick={dismiss} testId="host-hub-welcome-dialog-cta">
            <FormattedMessage
              defaultMessage="Take a look"
              id="host_hub.welcome_dialog.primary_button"
            />
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default HostHubWelcomeDialog;
